import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../img/Document scan.gif"
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import Pagination from "../../Pagination";
import SplitPane from "react-split-pane";

const SiteSubjectStatusList = ({ onMouseDown, tableRef }) => {
  const [subjectStatusList, setSubjectStatusList] = useState([]);
  const [subjectStatusCount, setSubjectStatusCount] = useState(0);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectStatusCount / itemsPerPage);

  const getStudySiteSubjectStatus = async () => {
    setDataLoader(true);
    let data = await studySiteDataEntryServices.getStudySiteSubjectStatus(studyId, "edc", StudyMode, pageNumber, itemsPerPage);
    setSubjectStatusList(data?.data || [])
    setSubjectStatusCount(data?.totalRecords || 0)
    setDataLoader(false);
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Study Id",
      "Site Id",
      "Subject Id",
      "Subject Gender",
      "Subject Status",
      "Screening Date",
      "Screening Status",
      "Screening Faild Reason",
      "Completion Status",
      "Completion Date",
      "Discontinue Status",
      "Discontinue Reason",
      "Randomization Status",
    ];
    const rows = data.map((row, index) => [
      index + 1,
      row.studyName || "",
      row.siteName || "",
      row.subjectName || "",
      row.subjectGender || "",
      row.status || "",
      row.screeningDate || "",
      row.screenStatus || "",
      row.screenFailedReason || "",
      row.completionStatus || "",
      row.completionDate || "",
      row.discontinueStatus || "",
      row.discontinueReason || "",
      row.randomizationStatus || "",
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "subject_status.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (!data || !data.length) return;
    const excelData = data.map((row, index) => ({
      "Sr.": index + 1,
      "Study Id": row.studyName,
      "Site Id": row.siteName,
      "Subject Id": row.subjectName,
      "Subject Gender": row.subjectGender,
      "Subject Status": row.status,
      "Screening Date": row.screeningDate,
      "Screening Status": row.screenStatus,
      "Screening Faild Reason": row.screenFailedReason,
      "Completion Status": row.completionStatus,
      "Completion Date": row.completionDate,
      "Discontinue Status": row.discontinueStatus,
      "Discontinue Reason": row.discontinueReason,
      "Randomization Status": row.randomizationStatus,
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Status");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "subject_status.xlsx");
  };

  useEffect(() => {
    getStudySiteSubjectStatus();
  }, [pageNumber, itemsPerPage]);

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-2">
          <div className="gap-1 hstack">
            <button
              onClick={() => downloadCSV(subjectStatusList)}
              className={`updateProfile`}
            >
              Download CSV
            </button>
            <button
              onClick={() => downloadExcel(subjectStatusList)}
              className={`updateProfile`}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {dataLoader ? (
          <PageLoader/>
        ) : subjectStatusList?.length === 0 ? (
          <NoDataFoundTable MSG={"Data Not Found!"} />
        ) : (
          <>
            <div className="overflow-auto">
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      className="text-center"
                      style={{ width: 45 }}
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Study Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Site Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Id</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Subject Gender</th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Subject Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Screening Date</th>
                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Screening Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Screening Faild Reason</th>
                    <th onMouseDown={(e) => onMouseDown(e, 9)}>Completion Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 10)}>Completion Date</th>
                    <th onMouseDown={(e) => onMouseDown(e, 11)}>Discontinue Status</th>
                    <th onMouseDown={(e) => onMouseDown(e, 12)}>Discontinue Reason</th>
                    <th onMouseDown={(e) => onMouseDown(e, 13)}>Randomization Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(subjectStatusList || []).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>
                        {rowIndex + 1 + startIndex}
                      </td>
                      <td>{row?.studyName}</td>
                      <td>{row?.siteName}</td>
                      <td>{row?.subjectName}</td>
                      <td>{row?.subjectGender}</td>
                      <td className={`fw-bold ${row?.status === "Active" ? "text-success" : "text-danger"}`}>{row?.status}</td>
                      <td>{row?.screeningDate}</td>
                      <td className={`fw-bold ${row?.screenStatus === "Pending" ? "text-secondary" : row?.screenStatus === "Screened" ? "text-success" : "text-danger"}`}>{row?.screenStatus}</td>
                      <td>{row?.screenFailedReason}</td>
                      <td className={`fw-bold ${row?.completionStatus === "Yes" ? "text-success" : "text-danger"}`}>{row?.completionStatus}</td>
                      <td>{row?.completionDate}</td>
                      <td className={`fw-bold ${row?.discontinueStatus === "Yes" ? "text-success" : "text-danger"}`}>{row?.discontinueStatus}</td>
                      <td>{row?.discontinueReason}</td>
                      <td className={`fw-bold ${row?.randomizationStatus === "Yes" ? "text-success" : "text-danger"}`}>{row?.randomizationStatus}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectStatusCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default SiteSubjectStatusList;